<template>
	<div>
		<a-table size="small" :columns="deductLogColumns" :data-source="deductLogList" bordered  :pagination="false" :loading="deductLogLoading" >
			<span slot="actionTimeSlot" slot-scope="text, record">
				{{getTimeFormatter(record.ActionTime)}}
			</span>
			<span slot="useCountSlot" slot-scope="text, record">
				{{getUseCount(record)}}
			</span>
		</a-table>
	</div>
</template>

<script>
	export default{
		props:['customerId'],
		data(){
			const deductLogColumns = [
				{
					title: '#',
					dataIndex: 'index',
					key: 'index',
					align: 'center',
					width: 50,
					customRender: (text,record,index) => `${index+1}`,
				},
				{
					title: '时间',
					dataIndex: 'ActionTime',
					scopedSlots:{customRender:'actionTimeSlot'},
					className:'v-cell',
					align:'center',
				},
				{
					title: '用量',
					scopedSlots:{customRender:'useCountSlot'},
					className:'v-cell',
					align:'center',
				},
			]
			return {
				deductLogColumns,
				deductLogList:[],
			}
		},
		methods:{
			getUseCount:function(item){
				if(item.changend>0){
					return item.MeterRead+item.changend-item.LastDeRead;
				}else{
					return item.MeterRead-item.LastDeRead;
				}
			},
			getTimeFormatter:function(dateTime){
				if(dateTime == null){
					return "";
				}else{
					let date = new Date(dateTime);
					return this.Config.formatDate(date);
				}
			},
			queryDeductLogList:function(){
				let url = this.Api.getLastUrl(this.Api.CHARGE_DEDUCT_LOG_LIST);
				let param = {customerId:this.customerId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.deductLogList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
		},
		created() {
			this.queryDeductLogList();
		}
	}
</script>

<style>
</style>
